import React, { PureComponent, Fragment } from 'react';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Spinner } from 'formlabs-web-components/Navigation';
import { Input, TextArea, Select } from 'formlabs-web-components/Form';
import { Header } from 'formlabs-web-components/Type';

import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';

import { analytics } from '../../utils';

import './ContactSales.module.css';
import CountrySelect from './selects/CountrySelect';
import identifyIntegrations from './identifyIntegrations';
import TextPlugin from '../cms/TextPlugin';

class SwabRequestForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      error: false,
      country: null
    };
    this.onClose = this.props.onClose;
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({ submitting: true, error: false });

    const csrftoken = Cookies.get('csrftoken');
    const form = e.target;
    const datasheets = this.props.datasheets;
    let form_data = new FormData(form);

    analytics.identify(
      form_data.get('tfa_5'),
      {
        email: form_data.get('tfa_5'),
        firstName: form_data.get('tfa_2'),
        lastName: form_data.get('tfa_3')
      },
      identifyIntegrations
    );

    let formtracking = 'Contact Sales Form Submitted';
    if (datasheets === true) {
      formtracking = 'Data Sheet Request Form Submitted';
    }

    analytics.track(
      `${formtracking}`,
      {
        category: 'Segment',
        email: form_data.get('tfa_5')
      },
      {
        integrations: {
          Marketo: false,
          'Marketo V2': false
        }
      }
    );
    fetch(form.action, {
      method: 'POST',
      body: form_data,
      headers: {
        'X-CSRFToken': csrftoken
      }
    })
      .then(res => res.json())
      .then(() => {
        this.setState({
          submitting: true
        });
      })
      .then(() => {
        this.setState({ submitting: false, submitted: true });
        setTimeout(
          function() {
            this.onClose();
          }.bind(this),
          1000
        );
      })
      .catch(error => {
        this.setState({
          submitted: false,
          submitting: false,
          error: true
        });
      });
  }

  onSelectCountry = e => {
    this.setState({ country: e.target.value });
  };

  render() {
    const {
      t,
      path,
      buttonText,
      title,
      body,
      boldTitle,
      datasheets
    } = this.props;
    const { submitting, submitted, error, country } = this.state;

    let tfa_dbFormId = '340164';
    let tfa_dbControl = 'b3d2132f1a899696a53af585df7dd656';

    if (datasheets === true) {
      tfa_dbFormId = '4755806';
      tfa_dbControl = '75a2db41f1dac9084cbd874aca5213c6';
    }

    if (submitted) {
      return (
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={24} secondaryAlignment="align-self-middle">
            {t('Thanks for your submission.')}
          </Cell>
        </Grid>
      );
    }
    const isUs = country === 'United States';
    return (
      <Fragment>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={24}>
            <Header level={4} displayAs={4} weight={boldTitle ? 700 : 400}>
              {title}
            </Header>
          </Cell>
          <Cell mediumSize={24}>
            <TextPlugin body={body}>{body}</TextPlugin>
            <p>
              Complete the form below and our COVID-19 response team will follow
              up as soon as possible. Need to contact us immediately? Call
              &nbsp;
              <a href="tel:1-617-453-2313">1-617-453-2313</a>.
            </p>
          </Cell>
        </Grid>
        <form
          action="/form_proxy/"
          className="contact-sales-form ga-track"
          data-ga-action="Submit sales inquiry"
          id="tfa_0"
          method="POST"
          styleName="contact-form"
          onSubmit={this.onFormSubmit.bind(this)}
        >
          <Input
            id="Campaign_ID"
            name="tfa_29"
            type="hidden"
            value="701i0000000f64K"
          />
          <Input
            id="Referral URL"
            maxLength="255"
            name="tfa_30"
            type="hidden"
            value=""
          />
          <Input
            id="Current URL"
            maxLength="255"
            name="tfa_54"
            type="hidden"
            value={path}
          />
          <Input
            id="Language Preference"
            maxLength="255"
            name="tfa_35"
            type="hidden"
            value=""
          />
          <Input
            id="Referral ID"
            maxLength="255"
            name="tfa_36"
            type="hidden"
            value=""
          />
          {datasheets === true && (
            <Input
              id="Data Sheet Request"
              maxLength="255"
              name="datasheets"
              type="hidden"
              value="datasheets"
            />
          )}
          <Input
            id="contact-sales-user-id"
            maxLength="255"
            name="tfa_37"
            type="hidden"
          />
          <Input id="_mkt_trk" name="_mkt_trk" type="hidden" />
          <Input id="_tfa_mkt_trk" name="tfa_39" type="hidden" />
          <Input id="acquisition_source_first" name="tfa_40" type="hidden" />
          <Input id="acquisition_source_last" name="tfa_41" type="hidden" />
          <Input id="gclid" name="tfa_42" type="hidden" />
          <Input id="utm_campaign_first" name="tfa_44" type="hidden" />
          <Input id="utm_campaign_latest" name="tfa_45" type="hidden" />
          <Input type="hidden" id="utm_pt_first" name="tfa_46" />
          <Input type="hidden" id="utm_pt_latest" name="tfa_47" />
          <Input type="hidden" id="utm_content_first" name="tfa_48" />
          <Input type="hidden" id="utm_content_latest" name="tfa_49" />
          <Input type="hidden" id="utm_term_first" name="tfa_50" />
          <Input type="hidden" id="utm_term_latest" name="tfa_51" />
          <Input type="hidden" id="utm_medium_first" name="tfa_52" />
          <Input type="hidden" id="utm_medium_latest" name="tfa_53" />

          <Grid direction="x" gutters="margin">
            <Cell mediumSize={8}>
              <label htmlFor="tfa_2">{t('First name')}</label>
              <Input
                id="tfa_2"
                maxLength="40"
                name="tfa_2"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_3">{t('Last name')}</label>
              <Input
                id="tfa_3"
                maxLength="40"
                name="tfa_3"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_7">{t('Hospital Name')}</label>
              <Input
                id="tfa_7"
                maxLength="40"
                name="tfa_7"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_58">
                {t('Health system name (If Applicable)')}
              </label>
              <Input
                id="tfa_58"
                maxLength="40"
                name="tfa_58"
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_5">{t('Work Email')}</label>
              <Input
                id="tfa_5"
                maxLength="40"
                name="tfa_5"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_6">{t('Phone Number')}</label>
              <Input
                id="tfa_6"
                maxLength="40"
                name="tfa_6"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_19">{t('Country')}</label>
              <CountrySelect
                id="tfa_19"
                name="tfa_19"
                required
                withFavorites
                onChange={this.onSelectCountry}
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_59">
                {t('Are you a medical professional/hospital?')}
              </label>
              <Select id="tfa_59" name="tfa_59" required>
                <option value="">– {t('Select')} –</option>
                <option value="yes">Yes</option>option>
                <option value="no">No</option>
              </Select>
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_33">{t('Profession')}</label>
              <Select id="tfa_33" name="tfa_33" required>
                <option value="">– {t('Select')} –</option>
                <option value="Supply Chain Professional">
                  Supply Chain Professional
                </option>
                option>
                <option value="Medical Professional">
                  Medical Professional
                </option>
                <option value="Other">Other</option>
              </Select>
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_56">{t('Quantity Desired')}</label>
              <Input
                id="tfa_56"
                maxLength="40"
                name="tfa_56"
                required
                size="20"
                type="number"
                min="1"
              />
            </Cell>
            <Cell mediumSize={8}>
              <label htmlFor="tfa_57">{t('Desired Arrival Date')}</label>
              <Input
                id="tfa_57"
                maxLength="40"
                name="tfa_57"
                required
                size="20"
                type="date"
              />
            </Cell>
            <Cell mediumSize={24}>
              <label htmlFor="tfa_34">{t('Other Comments')}</label>
              <TextArea
                id="tfa_34"
                name="tfa_34"
                rows="3"
                type="text"
                wrap="soft"
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="margin">
            <Cell backgrounmediumSize={24}>
              {!submitting && !submitted && (
                <input className="button" type="submit" value={buttonText} />
              )}
              {submitting && !submitted && (
                <span styleName="submitting">
                  <Spinner size={3} color="#0762c8" />
                </span>
              )}
              <Input
                id="tfa_dbFormId"
                name="tfa_dbFormId"
                type="hidden"
                value="4755819"
              />
              <Input
                id="tfa_dbResponseId"
                name="tfa_dbResponseId"
                type="hidden"
                value=""
              />
              <Input
                id="tfa_dbControl"
                name="tfa_dbControl"
                type="hidden"
                value="434b4da72b38a384754b2346ca13fb17"
              />
              <Input
                id="tfa_dbVersionId"
                name="tfa_dbVersionId"
                type="hidden"
                value="5"
              />
              <Input
                id="tfa_switchedoff"
                name="tfa_switchedoff"
                type="hidden"
                value=""
              />
            </Cell>
            <Cell mediumSize={16} secondaryAlignment="align-self-middle">
              {error && !submitted && (
                <span styleName="error">
                  <small>
                    {t(
                      'There was an error submitting your request. Please try again!'
                    )}
                  </small>
                </span>
              )}
            </Cell>
          </Grid>
        </form>
      </Fragment>
    );
  }
}

export default withTranslation()(SwabRequestForm);
